import { render, staticRenderFns } from "./NutritionInstructions.vue?vue&type=template&id=3ef978da&scoped=true"
import script from "./NutritionInstructions.vue?vue&type=script&lang=js"
export * from "./NutritionInstructions.vue?vue&type=script&lang=js"
import style0 from "./NutritionInstructions.vue?vue&type=style&index=0&id=3ef978da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef978da",
  null
  
)

export default component.exports